import { localeRequestHeaders } from '../localePreference';
import { apiErrorMessage } from '../apiErrorMessages';

const API_PREFIX = '/api/v1';

async function emailIntegrationRequest(path, user, options = {}) {
  const token = await user.getIdToken();
  let response;

  try {
    response = await fetch(`${API_PREFIX}/email-integrations${path}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...localeRequestHeaders(),
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error(apiErrorMessage('emailNetwork'));
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || apiErrorMessage('emailRequest'));
  }

  return response.json();
}

export function getEmailIntegrationStatus(user) {
  return emailIntegrationRequest('/status', user);
}

export function startEmailProviderConnection(user, provider, redirectPath = '/settings') {
  return emailIntegrationRequest(`/${provider}/connect`, user, {
    method: 'POST',
    body: JSON.stringify({ redirectPath }),
  });
}

export function disconnectEmailProvider(user, provider) {
  return emailIntegrationRequest(`/${provider}`, user, {
    method: 'DELETE',
  });
}

export function exchangeEmailProviderCode({ user, provider, code, state }) {
  return emailIntegrationRequest(`/${provider}/callback`, user, {
    method: 'POST',
    body: JSON.stringify({ code, state, provider }),
  });
}
